import { useEffect, useRef, useState } from 'react';
import type { ScrollSnapSlider } from 'scroll-snap-slider';
import type { IOptions } from '../shared/types';
import setupScrollSnapSlider from './setupScrollSnapSlider';

export default function useScrollSnapSlider<T extends HTMLElement = HTMLDivElement>(options: IOptions) {
    const sliderRef = useRef<T | null>(null);
    const [sliderInstance, setSliderInstance] = useState<ScrollSnapSlider>();

    useEffect(() => {
        if (options && sliderRef.current && !sliderInstance) {
            setSliderInstance(setupScrollSnapSlider({ ...options, sliderRef: sliderRef.current }));
        }

        return () => {
            if (sliderInstance) {
                sliderInstance.destroy();
            }
        };
    }, [options, sliderInstance, sliderRef]);

    return { ref: sliderRef, slider: sliderInstance };
}
